export const ACTIVITIES_POINTS_INFO = 'ReportInfo - ActivityPoints';
export const DOWNLOAD_PARTICIPATION_REPORT_URL = '@SchoolUsageReportsGatewayBaseUrl/' +
    'School/Download/Classroom/ParticipationReport';
export const DOWNLOAD_SERVICE_IS_ACTIVE = 'DOWNLOAD_SERVICE_IS_ACTIVE';

export const LIVE_MATHS_HEADER = 'Header - LiveMaths';

export const LIVE_MATHS_INFO = 'ReportInfo - LiveMaths';

export const WEEKLY_POINTS_INFO = 'ReportInfo - PointsInfo';

export const SKILL_QUEST_POINTS_INFO = 'ReportInfo - SkillQuestInfo';
export const NEW_COURSES_POINTS_INFO = 'ReportInfo - NewCoursesInfo';
export const CHALLENGES_POINTS_INFO = 'ReportInfo - ChallengesInfo';

export const WEEKLY_POINTS = 'ReportInfo - WeeklyPoints';

export const ACTIVITIES_TABLE_CONFIG = {
    cols: [
        {
            id: 'name',
            name: 'Activity',
            trans: 'Label - Activity'
        },
        {
            id: 'result',
            name: 'Results',
            classes: 'text-center',
            trans: 'Label - Results'
        },
        {
            id: 'points',
            name: 'Points',
            classes: 'text-center',
            trans: 'Label - Points'
        },
        {
            id: 'completionDate',
            name: 'Date completed',
            classes: 'text-center',
            trans: 'Label - DateCompleted'
        }
    ],
    footer: {
        cols: [
            { id: 'result', footerDataId: 'averageResult' },
            { id: 'points', footerDataId: 'totalPoints' }
        ]
    },
    emptyDataMessage: 'Empty - NoActivities'
};

export const LIVE_MATHS_TABLE_CONFIG = {
    cols: [
        {
            id: 'level',
            name: 'Level',
            trans: 'Label - Level'
        },
        {
            id: 'correct',
            name: 'Correct',
            classes: 'text-center',
            trans: 'Label - Correct'
        },
        {
            id: 'points',
            name: 'Points',
            classes: 'text-center',
            trans: 'Label - Points'
        },
        {
            id: 'accuracy',
            name: 'Accuracy',
            classes: 'text-center',
            trans: 'Label - Accuracy'
        }
    ],
    footer: {
        cols: [
            { id: 'level', footerDataId: 'maxLiveMathsLevels' },
            { id: 'correct', footerDataId: 'averageCorrect' },
            { id: 'points', footerDataId: 'totalPoints' }
        ]
    },
    emptyDataMessage: 'Empty - LevelsWithResults'
};

export const NEW_COURSES_TABLE_CONFIG = {
    cols: [
        {
            id: 'name',
            name: 'Activity',
            trans: 'Label - Activity'
        },
        {
            id: 'accuracy',
            name: 'Results',
            classes: 'text-center',
            trans: 'Label - Results'
        },
        {
            id: 'points',
            name: 'Points',
            classes: 'text-center',
            trans: 'Label - Points'
        },
        {
            id: 'completionDate',
            name: 'Date completed',
            classes: 'text-center',
            trans: 'Label - DateCompleted'
        }
    ],
    footer: {
        cols: [
            { id: 'accuracy', footerDataId: 'averageResult' },
            { id: 'points', footerDataId: 'totalPoints' }
        ]
    },
    emptyDataMessage: 'EmptyMessage - NewCourses'
};

export const SKILL_QUEST_TABLE_CONFIG = {
    cols: [
        {
            id: 'name',
            name: 'Activity',
            trans: 'Label - Activity'
        },
        {
            id: 'accuracy',
            name: 'Results',
            classes: 'text-center',
            trans: 'Label - Results'
        },
        {
            id: 'completionDate',
            name: 'Date completed',
            classes: 'text-center',
            trans: 'Label - DateCompleted'
        }
    ],
    footer: {
        cols: [
            { id: 'accuracy', footerDataId: 'averageAccuracy' }
        ]
    },
    emptyDataMessage: 'Empty - LevelsWithResults'
};
export const CHALLENGES_TABLE_CONFIG = {
    cols: [
        {
            id: 'name',
            name: 'Activity',
            trans: 'Label - Activity'
        },
        {
            id: 'accuracy',
            name: 'Results',
            classes: 'text-center',
            trans: 'Label - Results'
        },
        {
            id: 'points',
            name: 'Points',
            classes: 'text-center',
            trans: 'Label - Points'
        },
        {
            id: 'completionDate',
            name: 'Date completed',
            classes: 'text-center',
            trans: 'Label - DateCompleted'
        }
    ],
    footer: {
        cols: [
            { id: 'accuracy', footerDataId: 'averageResult' },
            { id: 'points', footerDataId: 'totalChallengesPoints' }
        ]
    },
    emptyDataMessage: 'EmptyMessage - Challenges'
};



// WEBPACK FOOTER //
// ./containers/participation-report/participation-report-constants.js